import { http, httpV2 } from "@/api";

/**
 * @summary Solicita o resultado do mancal principal para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetMainBearingResult = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/MainBearings`);
};

/**
 * @summary Solicita o resultado da gearbox para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetGeaboxResult = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`);
};

/**
 * @summary Solicita o resultado do gerador para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetGeneratorResult = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/GeneratorBearings`);
};

/**
 * @summary Solicita o gráfico do diagnóstico para um resultado e mancal.
 * @param {number} parameters Id do conjunto de resultado.
 * @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
 */
const GetChart = function(resultSetId, bearingId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/RollingBearingsChart`, {
		params:           bearingId,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	 });
};

/**
 * @summary Obtém os rolamentos relacionados à um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Retorna um conjunto de rolamentos.
 */
const GetBearings = async function(id)
{
	return httpV2.get(`/RollingBearingFailuresSettings/${id}/Bearings`);
};

export default {
	GetMainBearingResult, GetGeaboxResult, GetGeneratorResult, GetChart, GetBearings
};